import { RouterModule, PreloadAllModules } from '@angular/router';
import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';
import { PORTAL_ROUTES } from '@modules/portal/portal.routes';
import { AUTH_ROUTES } from '@modules/auth/auth.routes';
import { PORTAL_ROUTE_NAMES } from '@modules/portal/portal.routes.names';
import { NOT_FOUND_ROUTE_NAMES } from '@modules/not-found/not-found.route.names';

export const routes: Routes = [
  {
    path: '',
    redirectTo: PORTAL_ROUTE_NAMES.DASHBOARD,
    pathMatch: 'full',
  },
  {
    path: '',
    children: PORTAL_ROUTES,
    data: {
      depth: 2,
    },
  },
  {
    path: '',
    children: AUTH_ROUTES,
    data: {
      depth: 1,
    },
  },
  {
    path: '**',
    redirectTo: NOT_FOUND_ROUTE_NAMES.NOT_FOUND,
    data: {
      depth: 3,
    },
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
